import React, { useCallback, useContext } from 'react';
import { ModalContext } from '../providers/ModalProvider';
import { UrlSettingsContext } from '../providers/UrlSettingsProvider';
import share from '../images/share.png';
import styles from './ShareButton.module.scss';
import useLocalize from '../hooks/use-localize';

const ShareButton = () => {
  const { localize } = useLocalize();
  const { copyUrlToClipboard } = useContext(UrlSettingsContext);
  const showModal = useContext(ModalContext);

  const shareResult = useCallback(async () => {
    try {
      await copyUrlToClipboard();
      showModal(localize('share.copied_to_clipboard'));
    } catch {
      showModal(localize('share.manual_copy'));
    }
  }, []);

  return (
    <button className={styles.share} onClick={shareResult}>
      <img alt={localize('share.alt')} src={share} title={localize('share.title')} />
    </button>
  );
};

export default ShareButton;
